import { render, staticRenderFns } from "./DashboardReport.vue?vue&type=template&id=910de0de"
import script from "./DashboardReport.vue?vue&type=script&lang=js"
export * from "./DashboardReport.vue?vue&type=script&lang=js"
import style0 from "./DashboardReport.vue?vue&type=style&index=0&id=910de0de&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
